export default {
    data(){
        return {
            ele: {},
            pos : { top: 0, left: 0, x: 0, y: 0 },
            currentPositionLeft:0,
            isSliderVisible:false,
        }
    },
    watch:{
        isSliderVisible:{
            deep:true,
            handler(val){
                if(val){
                    this.autoSlideInterval();
                } else {
                    clearInterval(this._timerId)
                    clearInterval(this._timerIdReturnBeginSlider)
                }
            }
        },
        currentPositionLeft:{
            handler(newValue){
                if(newValue === 0){
                    clearInterval(this._timerIdReturnBeginSlider)
                }

                if(newValue === this.ele.scrollWidth - this.ele.clientWidth){
                    this.returnToBeginningSlider()
                }
            }
        }
    },
    mounted(){
        this.ele = document.getElementById('carousel-drag');
        this.ele.addEventListener('mousedown', this.mouseDownHandler);
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    clearTimeout(this._timerForScroll)
                    this._timerForScroll = setTimeout(() => {
                        this.setSliderVisibleVal(true);
                    }, 200);
                } else {
                  clearTimeout(this._timerForScroll)
                  this.setSliderVisibleVal(false);
                }
              });
            // We will fill in the callback later...
        });
        this.observer.observe(this.ele);
        
    },
    methods:{
        mouseDownHandler(e){
            this.pos = {
                // The current scroll
                left: this.ele.scrollLeft,
                top: this.ele.scrollTop,
                // Get the current mouse position
                x: e.clientX,
                y: e.clientY,
            };
        document.addEventListener('mousemove', this.mouseMoveHandler);
        document.addEventListener('mouseup', this.mouseUpHandler);
        },

        mouseMoveHandler(e){
            const dx = e.clientX - this.pos.x;
            const dy = e.clientY - this.pos.y;
            // Scroll the element
            this.ele.scrollTop = this.pos.top - dy;
            this.ele.scrollLeft = this.pos.left - dx;
            this.currentPositionLeft = this.ele.scrollLeft; 
        },

        mouseUpHandler() {
                document.removeEventListener('mousemove', this.mouseMoveHandler);
                document.removeEventListener('mouseup', this.mouseUpHandler);
        },

        autoSlideInterval() {
            clearInterval(this._timerId)
            this._timerId = setInterval(() => {
                this.ele.scrollLeft += 1.3
                this.currentPositionLeft = this.ele.scrollLeft;
            }, 10);
        },

        returnToBeginningSlider() {
            clearInterval(this._timerIdReturnBeginSlider)
            this._timerIdReturnBeginSlider = setInterval(() => {
                this.ele.scrollLeft -= 20
                this.currentPositionLeft = this.ele.scrollLeft;
            }, 20);
        },

        setSliderVisibleVal(val) {
            this.isSliderVisible = val;
        },
}}